export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[400px] md:min-h-[480px]">
      {/* Left: Image Panel */}
      <div className="lg:w-1/2 relative h-[300px] lg:h-auto overflow-hidden bg-foreground-800">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylish%20modern%20flat%20lay%20composition%20with%20assorted%20fashion%20items%20including%20sneakers%20a%20tote%20bag%20sunglasses%20and%20a%20scarf%20arranged%20artfully%20on%20a%20warm%20cream%20linen%20background%2C%20soft%20diffused%20natural%20window%20lighting%2C%20editorial%20product%20photography%2C%20clean%20minimal%20Scandinavian%20aesthetic%2C%20neutral%20warm%20beige%20tones%2C%20sophisticated%20relaxed%20vibe%2C%20no%20text%20no%20logos%2C%20high%20detail%20balanced%20composition&width=900&height=600&seq=cta-product-flatlay-new-41&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti"
          className="w-full h-full object-cover"
          title="Scopri Itaobuy Spreadsheet"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
        <div className="absolute bottom-8 left-8">
          <p className="text-white/70 text-xs font-label mb-1">kaspreadsheet.com</p>
          <p className="text-white text-3xl md:text-4xl font-heading font-bold leading-tight">
            Vai alla<br />Piattaforma<br />Principale
          </p>
        </div>
      </div>

      {/* Right: CTA Panel */}
      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-8 py-16 md:py-0">
        <div className="text-center max-w-md">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            Unisciti a<br />Itaobuy
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            Accedi alla piattaforma principale per esplorare il database completo di prodotti. Migliaia di articoli di moda ti aspettano con prezzi aggiornati e recensioni verificate.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-label font-semibold cursor-pointer whitespace-nowrap hover:bg-foreground-800 transition-colors"
          >
            <span>Buy It Now</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}